<shared-contact-form
  [isLocked]="locked$ | async"
  [isSending]="sending$ | async"
  [isSent]="sent$ | async"
  [hasError]="error$ | async"
  (valid)="performContact($event)"
  (cancel)="onCancel()"
></shared-contact-form>

